import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
class Button extends PureComponent {
  render() {
    const { text, style, onClick, to, image, className } = this.props;

    if (to)
      return (
        <Link
          className={`component-btn component-focus flex-row align-center ${className}`}
          style={style}
          to={to}
        >
          {image && <img src={image} alt="imagem" />}
          {text}
        </Link>
      );

    return (
      <span
        className={`component-btn component-focus flex-row align-center ${className}`}
        style={style}
        onClick={onClick}
      >
        {image && <img src={image} alt="imagem" />}
        {text}
      </span>
    );
  }
}

export default Button;
